/**
 * String manipulation Utitls
 * @namespace StringParser
 */

// import _ from "lodash";

export default class StringParser {
    /**
     * Extract url from String
     * @param {String} string
     * @param {Function} callback
     */
    static extractUrl({string = '', callback} = {}) {
       let url  = string.match(/\bhttps?:\/\/\S+/gi);


       if(!url) return [];

       /* Cleaup remove quote / double quote from the url and what it comes after that */
       url = [...url.map(u => {

        if(u.indexOf("'") > 0) {
            return u.replace(u.substring(u.indexOf("'"), u.length), '')
        }

        if(u.indexOf('"') > 0) {
            return u.replace(u.substring(u.indexOf('"'), u.length), '');
        }


        return u;

       })]

        // const lastUrl = Array.isArray(url)  ? _.last(url) : url;

    //    console.log('urlurlurl', lastUrl)


       return callback?.(url) || url;
    }

    /**
     *  Generate random string
     * @param {Number} length
     */
    static makeString(length) {
        let   result     = '';
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

        const charactersLength = characters.length;

        for ( let i = 0; i < length; i++ ) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
       return result;
    }

    /**
     * Convert string to json object
     * @param {String} string
     * @returns {Object|null}
     */
    static stringToJson(string) {
        if(!string) return null;

        try {
            const json = JSON.parse(string);

            return json;
        } catch (e) {
            console.error(string, 'Error parsing string to JSON:', e);
            return null;
        }
    }
}